import React, { useState } from 'react';
import {
  Button,
  Column,
  Copy,
  Heading,
  Row,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { useGetAdminById } from 'src/components/enterprise/Parents/Admin/hooks/useGetAdminById/useGetAdminById';
import { SimpleDialog } from 'src/components/SimpleDialog/SimpleDialog';
import { useDeactivateParentAccountAdmin } from 'src/components/enterprise/Parents/Admin/hooks/useDeactivateParentAccountAdmin/useDeactivateParentAccountAdmin';
import { RouterButtonLink } from 'src/components/RouterLink/RouterButtonLink';

export interface IParentAdminsHeaderProps {
  corpId: string;
  dinerId: string;
}

export const ParentAdminOverviewHeader: React.FC<IParentAdminsHeaderProps> = ({
  corpId,
  dinerId,
}) => {
  const editParentAdminLink = `/corporate/enterprise/parents/${corpId}/admin/${dinerId}/edit`;

  const { diner } = useGetAdminById(corpId, dinerId);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const { deactivate, isLoading: isDeactivateLoading } =
    useDeactivateParentAccountAdmin();

  if (!diner) {
    return null;
  }

  const handleDeactivate = () => {
    setShowConfirmationModal(false);
    deactivate({
      diner,
      corpId,
    });
  };

  return (
    <Row gutter={24}>
      <Column phone={10} gutter={24}>
        <Stack y="x-sm">
          <Heading variant="h5">
            {diner.last_name}, {diner.first_name}
          </Heading>
        </Stack>
        <Copy variant="body" color="secondaryText">
          Email: {diner.email}
        </Copy>
      </Column>
      <Column phone={2} gutter={24} style={{ textAlign: 'center' }}>
        <RouterButtonLink
          href={editParentAdminLink}
          buttonVariant="secondary"
          buttonSize="medium"
          useBlockButton
        >
          Edit
        </RouterButtonLink>
        <Button
          onClick={() => {
            setShowConfirmationModal(true);
          }}
          variant="tertiary"
          buttonSize="medium"
          disabled={isDeactivateLoading}
        >
          Deactivate
        </Button>
      </Column>

      {showConfirmationModal && (
        <SimpleDialog
          id={dinerId}
          title="Are you sure?"
          description="Deactivating this admin will remove their access to this parent account"
          primaryActionText="Deactivate"
          buttonsDirection="row"
          secondaryActionText="Cancel"
          onSecondaryActionClick={() => {
            setShowConfirmationModal(false);
          }}
          onPrimaryActionClick={handleDeactivate}
        />
      )}
    </Row>
  );
};
